import { useEffect, useState } from 'react';
import { useAppContext } from '../context/AppContext';
import assetPath from '../utils/assetPath';
import copy from '../data/copy';
import PartnerSlider from '../components/PartnerSlider';
import Seo from '../components/Seo';

const Home = () => {
  const { language } = useAppContext();
  const t = copy[language];
  const [logoMotion, setLogoMotion] = useState({
    rotate: 0,
    translate: 0,
    scale: 1,
    glow: 0.4,
    blur: 20,
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    let rafId = null;

    const updateMotion = () => {
      const { scrollY, innerHeight } = window;
      const progress = Math.max(0, Math.min(scrollY / Math.max(innerHeight, 1), 1));
      setLogoMotion({
        rotate: progress * 16,
        translate: progress * 38,
        scale: 1 + progress * 0.08,
        glow: 0.4 + progress * 0.35,
        blur: 20 + progress * 15,
      });
      rafId = null;
    };

    const handleScroll = () => {
      if (rafId !== null) {
        return;
      }
      rafId = window.requestAnimationFrame(updateMotion);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    updateMotion();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafId !== null) {
        window.cancelAnimationFrame(rafId);
      }
    };
  }, []);

  const logoMotionStyle = {
    '--logo-translate': `${logoMotion.translate}px`,
    '--logo-rotate': `${logoMotion.rotate}deg`,
    '--logo-scale': logoMotion.scale,
    '--logo-glow': logoMotion.glow,
    '--logo-blur': `${logoMotion.blur}px`,
  };

  return (
    <>
      <Seo
        title={language === 'fr' ? 'Accueil' : 'Home'}
        description={t.teamIntro.body}
        image={assetPath('/assets/logo-salty.png')}
      />
      <section id="hero" className="hero">
        <div className="hero-text">
          <p className="unit">{t.saltyLine}</p>
          <h1>{t.heroTitle}</h1>
          <p>{t.heroBody}</p>
          <div className="hero-cta">
            <a
              className="btn primary btn-icon"
              href="https://www.instagram.com/salty.airsoft/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <img src={assetPath('/assets/logo-instagram.webp')} alt="" aria-hidden="true" />
            </a>
            <a
              className="btn ghost btn-icon"
              href="https://discord.gg/ncMBPzqVza"
              target="_blank"
              rel="noreferrer"
              aria-label="Discord"
            >
              <img src={assetPath('/assets/logo-discord.png')} alt="" aria-hidden="true" />
            </a>
          </div>
        </div>
        <div className="hero-media">
          <div className="hero-logo-wrapper" style={logoMotionStyle}>
            <img src={assetPath('/assets/logo-salty.png')} alt="SΛLTY logo" className="hero-logo" />
          </div>
        </div>
      </section>

      <section className="team-intro">
        <h2>{t.teamIntro.title}</h2>
        <p>{t.teamIntro.body}</p>
      </section>

      <PartnerSlider copy={t.partners} language={language} />
    </>
  );
};

export default Home;
